import { render, staticRenderFns } from "./HistoryGroupConfig.vue?vue&type=template&id=1461af18&scoped=true"
import script from "./HistoryGroupConfig.vue?vue&type=script&lang=js"
export * from "./HistoryGroupConfig.vue?vue&type=script&lang=js"
import style0 from "./HistoryGroupConfig.vue?vue&type=style&index=0&id=1461af18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461af18",
  null
  
)

export default component.exports